// Lib
import { FC } from "react";
// Hooks
import { useExport } from "hooks";
// Icons
import { FileUploadIcon } from "icons";
// Styled
import { ExportButton } from "./styled";

interface ExportProps {
  type?: "Heading" | "Base";
  fileName: string;
  isLoading: boolean;
  isDataLoading: boolean;
  isDisabled: boolean;
  columns: Record<string, unknown>[];
  getExportData: () => Promise<Record<string, unknown>[]>;
}

export const Export: FC<ExportProps> = ({
  type = "Heading",
  isLoading,
  isDataLoading,
  isDisabled,
  fileName,
  columns,
  getExportData,
}) => {
  const { downloadCSV } = useExport();

  const Component = ExportButton[type];

  return (
    <Component
      icon={<FileUploadIcon />}
      loading={isLoading}
      disabled={isDisabled}
      onClick={() =>
        downloadCSV({ fileName, isDataLoading, columns, getExportData })
      }
    >
      Export
    </Component>
  );
};
